import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, shadow } from 'stylesheet';
import { WarningTriangle } from 'theme/icons';
var AffiliationWarningContainer = styled.span.withConfig({
  displayName: "AffiliationWarningstyle__AffiliationWarningContainer",
  componentId: "sc-zknngw-0"
})(["position:relative;padding:8px 34px 8px 10px;background-color:", ";border-radius:", ";box-shadow:", ";"], colorUsage.witheColor, borderRadius.large, shadow.bottom.dark);
var WarningIcon = styled(WarningTriangle).withConfig({
  displayName: "AffiliationWarningstyle__WarningIcon",
  componentId: "sc-zknngw-1"
})(["position:absolute;top:5px;right:8px;width:24px;vertical-align:'bottom';& path{fill:", ";}"], colorUsage.message.warning);
var WarningMessage = styled.span.withConfig({
  displayName: "AffiliationWarningstyle__WarningMessage",
  componentId: "sc-zknngw-2"
})(["color:", ";font-size:", ";"], colorUsage.message.warning, fontSize.small);
export { AffiliationWarningContainer, WarningIcon, WarningMessage };